<template>
  <ViewCustomData entityName="news" serviceName="BaseService" :columns="COLUMNS" :dictionary="DICTIONARY"
    :toolbarFilters="TOOLBAR_FILTRES" entitySpec="data" scheme="news" @selectedRow="onSelectedRow"
    :dialogOptions="dialogOptions" @permissions="onSetPermissions" ref="viewNewsData" :prepareData="prepareData"
    :drawRow="rowClass" @dictIsReady="dictIsReady" :dialog="NewsDialog" />
</template>

<script setup>
import { ref, shallowRef } from 'vue';
import NDialog from './NewsDialog.vue';
import { TOOLBAR_FILTRES, DICTIONARY, COLUMNS } from './newsConstants';

const viewNewsData = ref(null);
const selected = ref(null);
const dialogOptions = ref({});
const NewsDialog = shallowRef(NDialog);

const onSelectedRow = (value) => {
  selected.value = value;
}

const onSetPermissions = (value) => { }

const prepareData = (data) => {
  return data;
}

const dictIsReady = (options, data) => {
  dialogOptions.value[options] = data;
}

const rowClass = (row) => {
  switch (row.news_severity_sysname) {
    case 'INFO':
      return 'row-accessories-green';
    case 'WARN':
      return 'row-accessories-orange';
    case 'HIGH':
      return 'row-accessories-red';
    default:
      return '';
  }
}
</script>